import { Component } from '@angular/core';

@Component({
    selector: 'app-sensors',
    templateUrl: './sensors.component.html',
    styleUrls: ['./sensors.component.scss'],
    standalone: false
})
export class SensorsComponent {}
